import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

interface IClient {
  logo?: string
  name: string
  description?: string
  link?: string
}

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomersComponent {
  @Input() header: string = '';
  @Input() customers: IClient[] | undefined = [];
}
